import React, { forwardRef } from 'react'
import classNames from 'classnames'

import InputContainer from './InputContainer'

import './Input.scss'
import { Textbox } from './Textbox'
import { ThemeColours } from '../../../../types/theme'

export type InputStatus = 'normal' | 'correct' | 'wrong'

interface Props extends React.InputHTMLAttributes<HTMLInputElement>,
  React.ComponentProps<typeof InputContainer> {
  allowLastPass?: boolean
  inputClassName?: string
  onFieldInvalid?: (errorMessage: string | undefined) => void
  colour?: ThemeColours
  status?: InputStatus
  isLabelHtml?: boolean
}

const Input = forwardRef<HTMLInputElement, Props>(({
  className,
  inputClassName,
  noBorder,
  label,
  labelFor,
  error,
  block,
  containerBlock,
  verticalCenter,
  autoFocus,
  large,
  small,
  reverse,
  right,
  helpTitle,
  helpDescription,
  allowLastPass = false,
  isVerticalLayout = false,
  type,
  status = 'normal',
  colour,
  isLabelHtml = false,
  ...rest
}, ref) => {
  return <InputContainer
    className={classNames(className, { block })}
    noBorder={noBorder}
    isLabelHtml={isLabelHtml}
    label={label}
    labelFor={labelFor}
    helpDescription={helpDescription}
    helpTitle={helpTitle}
    error={error}
    reverse={reverse}
    right={right}
    containerBlock={containerBlock}
    verticalCenter={verticalCenter}
    isVerticalLayout={isVerticalLayout}
    colour={colour}
  >
    {type !== 'textbox' && <input
      ref={ref}
      autoFocus={autoFocus}
      data-lpignore={allowLastPass ? 'false' : 'true'}
      className={classNames('input', inputClassName, { 'invalid': error, block, large, small,
        correct: status === 'correct',
        wrong: status === 'wrong'
      })}
      type={type}
      {...rest}
    />}
    {type === 'textbox' &&
      <Textbox
        ref={ref as any}
        role='textbox'
        className={classNames('input', inputClassName, {
          'invalid': error,
          block,
          large,
          small
        })}
        {...rest}
      />
    }
  </InputContainer>
})

export default Input
